$(document).ready(function () {
  // Handle hover for Mega Menu
  $(".mega-menu").hover(
    function () {
      $(this).find(".mega-menu__content").addClass("mega-menu-open");
    },
    function () {
      $(this).find(".mega-menu__content").removeClass("mega-menu-open");
    }
  );

  // Handle hover for all Dropdown Menus
  $(".dropdown-menu-wrapper").hover(
    function () {
      $(this).addClass("mega-menu-open");
    },
    function () {
      $(this).removeClass("mega-menu-open");
    }
  );

  // Handle <details> element for Mega Menu
  document
    .querySelectorAll(".header__inline-menu details.mega-menu")
    .forEach((item) => {
      const toggleOpen = (state) => item.toggleAttribute("open", state);
      item.addEventListener("mouseover", () => toggleOpen(true));
      item.addEventListener("mouseleave", () => toggleOpen(false));
      const content = item.querySelector(".mega-menu__content");
      if (content) {
        content.addEventListener("mouseover", () => toggleOpen(true));
        content.addEventListener("mouseleave", () => toggleOpen(false));
      }
    });

  // Dynamically handle all dropdown menus, including newly added ones
  $(".header__inline-menu").on(
    "mouseenter",
    ".dropdown-menu-wrapper",
    function () {
      $(this).addClass("mega-menu-open");
    }
  );

  $(".header__inline-menu").on(
    "mouseleave",
    ".dropdown-menu-wrapper",
    function () {
      $(this).removeClass("mega-menu-open");
    }
  );
});
